import driverPerformance from '@/api/report/driver-performance'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
    ...baseState,
    dateRange: [
        moment().format('DD-MM-YYYY'),
        moment().format('DD-MM-YYYY')
    ],
    driverIds: []
}

export const getters = {}

export const mutations = {
    ...baseMutations,
    SET_DATE_RANGE(state, dateRange) {
        state.dateRange = dateRange
    },
    SET_DRIVER_IDS(state, driverIds) {
        state.driverIds = driverIds
    }
}

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.currentPage,
                perPage: context.state.pagination.perPage,
                date_range: context.state.dateRange,
                driver_ids: context.state.driverIds
            },
            attributes
        )

        return driverPerformance.viewData({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    }
}
